import React, { Children } from 'react';
import { Variants } from 'framer-motion';
// Shared animation variants
export const fadeIn: Variants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
export const slideUp: Variants = {
  hidden: {
    y: 20,
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 30
    }
  },
  exit: {
    y: 20,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
export const slideInLeft: Variants = {
  hidden: {
    x: -20,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 30
    }
  },
  exit: {
    x: -20,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
export const slideInRight: Variants = {
  hidden: {
    x: 20,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 30
    }
  },
  exit: {
    x: 20,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
export const scaleIn: Variants = {
  hidden: {
    scale: 0.9,
    opacity: 0
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 25
    }
  },
  exit: {
    scale: 0.9,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
export const staggerContainer: Variants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
// Button hover animations
export const buttonHover = {
  scale: 1.03,
  transition: {
    duration: 0.2
  }
};
export const buttonTap = {
  scale: 0.97,
  transition: {
    duration: 0.1
  }
};
// Card hover animations
export const cardHover = {
  y: -5,
  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
  transition: {
    duration: 0.3
  }
};
// Page transitions
export const pageTransition: Variants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3,
      when: 'beforeChildren',
      staggerChildren: 0.1
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
// List item animations
export const listItem: Variants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 30
    }
  }
};